import { perfilData, PerfilesId } from "src/utils/perfil";
import {
    Box,
    Icon,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Typography,
  } from "@mui/material";
  import React from "react";
  
  interface SeleccionPerfilProps {
    valor: [PerfilesId, ...any[]];
  }
  
  
  const renderListItems = (items: string[]) => {
    return items.map((item, index) => (
      <ListItem key={index}>
        <ListItemIcon sx={{ minWidth: "30px" }}>
          <Icon fontSize="small">check</Icon>
        </ListItemIcon>
        <ListItemText primary={item} />
      </ListItem>
    ));
  };
  
  const SeleccionPerfil = ({ valor }: SeleccionPerfilProps) => {
    if (!valor || !perfilData[valor[0]]) return null;
  
    const { titulo, items } = perfilData[valor[0]];
  
    return (
      <Box>
        <Typography>
          Para seleccionar <b>{titulo}</b> debe tener en cuenta:
        </Typography>
        <Box pl={4} pt={2}>
          <List>{renderListItems(items)}</List>
        </Box>
      </Box>
    );
  };
  
  export default SeleccionPerfil;
  